import { render, staticRenderFns } from "./GiftPurchasesDetailsModal.vue?vue&type=template&id=21633f90&"
import script from "./GiftPurchasesDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./GiftPurchasesDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports